import { render, staticRenderFns } from "./CouponOnProductForm.vue?vue&type=template&id=aed6d474"
import script from "./CouponOnProductForm.vue?vue&type=script&lang=js"
export * from "./CouponOnProductForm.vue?vue&type=script&lang=js"
import style0 from "./CouponOnProductForm.vue?vue&type=style&index=0&id=aed6d474&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports